import React from 'react';
import WeducNoticesComp from './WeducNotices';
import { returnResizedImageURL } from '@accrosoft-ltd/accropress-websites-components/dist/esm/imgUtils';

var HeroInnerContent = function HeroInnerContent(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "HeroInnerContent"
  }, props && props.contentDataData && props.setNoticesMainLoaded && props.NoticeTemplate && props.toggleNoticesBanner && props.config && props.pluginOptions && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "banner home-banner",
    style: !props.pluginOptions.useHeroSlider ? {
      backgroundImage: "linear-gradient(\n                to bottom,\n                rgba(0, 0, 0, 0.4),\n                rgba(0, 0, 0, 0.1)\n              ),\n              url(\"" + (props.contentDataData[0].children[3] && props.contentDataData[0].children[3].value ? returnResizedImageURL({
        w: 1900
      }, props.contentDataData[0].children[3].value) : returnResizedImageURL({
        w: 1900
      }, '/banner.jpg')) + "\")"
    } : {}
  }, props.pluginOptions.heroVideoURL && /*#__PURE__*/React.createElement("video", {
    id: "hero_video_player",
    className: "hero__video",
    loop: true,
    muted: true,
    preload: "metadata",
    autoPlay: true,
    playsInline: true
  }, /*#__PURE__*/React.createElement("source", {
    className: "video__source",
    type: "video/mp4",
    "data-src": props.pluginOptions.heroVideoURL
  }), props.pluginOptions.heroVideoURL_OGG && /*#__PURE__*/React.createElement("source", {
    className: "video__source",
    "data-src": props.pluginOptions.heroVideoURL_OGG,
    type: "application/ogg"
  }), props.pluginOptions.heroVideoURL_WEBM && /*#__PURE__*/React.createElement("source", {
    className: "video__source",
    "data-src": props.pluginOptions.heroVideoURL_WEBM,
    type: "video/webm"
  })), /*#__PURE__*/React.createElement("div", {
    className: "container bannerContentContainer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bannerWrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bannerText"
  }, /*#__PURE__*/React.createElement("h1", null, props.contentDataData[0].children[0].value), props.contentDataData[0].children[1].value && /*#__PURE__*/React.createElement("h2", null, props.contentDataData[0].children[1].value), props.contentDataData[0].children[2].value && /*#__PURE__*/React.createElement("p", null, props.contentDataData[0].children[2].value)))), !props.pluginOptions.hideNotices && /*#__PURE__*/React.createElement("div", {
    className: 'noticesBanner weducWidgetDisplay_' + !props.toggled + ' noticesType_' + props.config.noticesType || 'normal'
  }, /*#__PURE__*/React.createElement(WeducNoticesComp, {
    config: props.config,
    noticesBannerExpanded: props.noticesBannerExpanded,
    NoticeTemplate: props.NoticeTemplate,
    toggled: props.toggled,
    setToggled: props.setToggled,
    noticesMainLoaded: props.noticesMainLoaded,
    setNoticesMainLoaded: props.setNoticesMainLoaded
  })))));
};

export default HeroInnerContent;